import { CaretDoubleDownIcon as PhosphorCaretDoubleDownIcon } from "@phosphor-icons/react/dist/ssr/CaretDoubleDown";

import { createAppIcon } from "@/components/createAppIcon";

export const DoubleChevronDownIcon = /* @__PURE__ */ createAppIcon(PhosphorCaretDoubleDownIcon);
